<template>
  <div class="main text-left">
    <div class="form-group">
      <label><span class="text-muted">会員ID</span><br>{{ this.$store.state.userinfo.cardid }}</label>
    </div>
    <div class="form-group">
      <label><span class="text-muted">ユーザーID</span><br>{{ this.$store.state.userinfo.email }}</label>
    </div>
    <div class="form-group">
      <label><span class="text-muted">カード発行日</span><br>{{ this.$store.state.userinfo.createdate }}</label>
    </div>
    <div class="form-group">
      <label class="text-muted small">お名前 <span class="text-danger">*必須</span></label>
      <input type="text" class="form-control form-control-sm" v-model="input.name" :maxlength="50">
    </div>
    <div class="form-group">
      <label class="text-muted small">携帯番号</label>
      <input type="text" class="form-control form-control-sm" v-model="input.phone" :maxlength="13">
    </div>
    <span class="btn btn-warning btn-sm" v-on:click="save()">保存する</span>
  </div>
</template>
<script>
import sx from '../utils/core.js'
import $ from "jquery";

export default {
  data() {
    return {
      input: {
        name: this.$store.state.userinfo.name,
        phone: this.$store.state.userinfo.phone
      },
      confirmdef: {
        title: '登録情報',
        msg: '保存しますか？',
        cancelText: 'キャンセル',
        okText: 'OK'
      }
    }
  },
  created() {
    this.$store.state.title = '登録情報の編集'
    this.$store.state.showBack = true
    this.$store.state.pageBack = 'My'
    this.$store.state.confirmdef = this.confirmdef
  },
  destroyed() {
    this.$store.state.showBack = false
  },
  methods: {
    toLogin() {
      this.$router.replace({ name: 'Login' })
    },
    save() {
      const that = this
      if (!sx.isNothingOrEmpty(that.input.name)) {
        $('#myModalConfirm').modal('show')
        $("#confirm").click(function () {
          $('#myModalConfirm').modal('hide')
          if (that.$router.currentRoute.name != "Profile") {
            return
          }
          sx.showWaiting()
          var params = {
            contactmobile: that.input.phone,
            contactname: that.input.name,
            token: localStorage.getItem('token')
          }
          var url = that.$store.state.baseurl + '/app/account/profile'
          sx.request(
            url,
            params,
            function (result) {
              if (result.status === 'ok') {
                that.$store.state.userinfo.name = that.input.name
                that.$store.state.userinfo.phone = that.input.phone
                sx.hideWaiting()
                sx.toastSuccess('更新しました！')
                that.$router.replace({ name: 'My' })
              }
            },
            function (result) {
              sx.login(
                url,
                params,
                function (result) {
                  if (result.status === 'ok') {
                    that.$store.state.userinfo.name = that.input.name
                    that.$store.state.userinfo.phone = that.input.phone
                    sx.hideWaiting()
                    sx.toastSuccess('更新しました！')
                    that.$router.replace({ name: 'My' })
                  } else {
                    sx.toastSuccess(result.message)
                    console.log(result.message)
                  }
                }
              )
            }
          )
          sx.hideWaiting()
        });
      } else {
        sx.toastError('お名前を入力してください！')
        console.log('A username and password must be present')
      }
    }
  }
}
</script>
<style scoped>
.main {
  padding: 20px;
}
</style>
